<ng-container *appRequirePermission="id ? ['patientInformation'] : []">
  <div class="row justify-content-end mx-1 mb-3">
    <div class="notes col-12 col-md-10" data-cy="PatientInformation-note">
      <i class="fa-light fa-triangle-exclamation pe-1"></i>
      {{ 'serviceData.form.patientInformationNote' | translate }}
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12 col-md-6">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label for="firstName">
            {{ 'serviceData.form.firstName' | translate }}
          </label>
        </div>
        <div class="col-12 col-sm-8">
          <input
            class="form-control"
            formControlName="firstName"
            id="firstName"
            appInputValidationStatus
            data-cy="FirstName-input"
            [placeholder]="
              'serviceData.form.placeholders.firstName' | translate
            "
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error
            for="firstName"
            translations="serviceData.form.validation.name"
            data-cy="FirstName-validation-error"
          ></app-validation-error>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6 mt-3 mt-md-0">
      <div class="row align-items-center">
        <div class="col-12 col-sm-4 mb-1">
          <label for="lastName">
            {{ 'serviceData.form.lastName' | translate }}
          </label>
        </div>
        <div class="col-12 col-sm-8">
          <input
            class="form-control"
            formControlName="lastName"
            id="lastName"
            appInputValidationStatus
            data-cy="LastName-input"
            [placeholder]="'serviceData.form.placeholders.lastName' | translate"
          />
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-12 col-sm-8">
          <app-validation-error
            for="lastName"
            translations="serviceData.form.validation.name"
            data-cy="LastName-validation-error"
          ></app-validation-error>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<div class="row mb-3" *appRequirePermission="id ? ['medicalInformation'] : []">
  <div class="col-12 col-md-6">
    <div class="row align-items-center">
      <div class="col-12 col-sm-4 mb-1">
        <label for="dateOfBirth">{{
          'serviceData.form.dateOfBirth' | translate
        }}</label>
      </div>
      <div class="col-12 col-sm-8">
        <input
          ngbDatepicker
          class="form-control"
          id="dateOfBirth"
          formControlName="dateOfBirth"
          appInputValidationStatus
          container="body"
          #birthdayDatepicker="ngbDatepicker"
          data-cy="DateOfBirth-input"
          [minDate]="momentToNgbDate(minDate)"
          [maxDate]="momentToNgbDate(maxDate)"
          [startDate]="momentToNgbDate(birthdayStartDate)"
          [placeholder]="'serviceData.form.placeholders.dateFormat' | translate"
          (click)="birthdayDatepicker.toggle()"
        />
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 col-sm-8">
        @let dateOfBirthControl = form.get('dateOfBirth');
        @if (
          dateOfBirthControl.errors?.ngbDate?.maxDate &&
          (dateOfBirthControl.dirty || dateOfBirthControl.touched)
        ) {
          <div class="pt-1 pb-2" data-cy="DateOfBirth-validation-error">
            <span class="text-danger caption">
              {{ 'validation.dateOfBirth.maxDate' | translate }}
            </span>
          </div>
        } @else {
          <app-validation-error
            for="dateOfBirth"
            translations="validation.generic"
            data-cy="DateOfBirth-validation-error"
          ></app-validation-error>
        }
      </div>
    </div>
  </div>
</div>
<div class="row mb-3" *appRequirePermission="id ? ['patientInformation'] : []">
  <div class="col-12 col-md-6">
    <div class="row align-items-center">
      <div class="col-12 col-sm-4 mb-1">
        <label for="email">{{ 'serviceData.form.email' | translate }}</label>
      </div>
      <div class="col-12 col-sm-8">
        <input
          class="form-control"
          formControlName="email"
          id="email"
          appInputValidationStatus
          data-cy="Email-input"
          [placeholder]="'serviceData.form.placeholders.email' | translate"
        />
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 col-sm-8">
        <app-validation-error
          for="email"
          translations="validation.generic"
          data-cy="Email-validation-error"
        ></app-validation-error>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-6 mt-3 mt-md-0">
    <div class="row align-items-center">
      <div class="col-12 col-sm-4 mb-1">
        <label for="phoneNumber">{{
          'serviceData.form.phoneNumber' | translate
        }}</label>
      </div>
      <div class="col-12 col-sm-8">
        <input
          class="form-control"
          formControlName="phoneNumber"
          id="phoneNumber"
          appInputValidationStatus
          data-cy="PhoneNumber-input"
          [placeholder]="
            'serviceData.form.placeholders.phoneNumber' | translate
          "
        />
      </div>
    </div>
    <div class="row justify-content-end">
      <div class="col-12 col-sm-8">
        <app-validation-error
          for="phoneNumber"
          translations="validation.generic"
          data-cy="PhoneNumber-validation-error"
        ></app-validation-error>
      </div>
    </div>
  </div>
</div>
